export const formatPayload = (payload: any): { productId: string; nbaId: string } => {
  const nbaId = payload?.nbaid ?? null;
  let productId = null;
  const productIds = payload?.productids;
  if (Array.isArray(productIds) && productIds.length > 0) {
    productId = productIds[0];
  }
  return {
    productId,
    nbaId,
  };
};
